import * as types from '../types'
// state
const state = {
  navtitle: '',
  navpath: [],
  lang: 'en'
}

const mutations = {
  [types.NAVINFO](state, result) {
    state.navtitle = result.navtitle
    state.navpath = result.navpath
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/nav.js